import React from "react";
import * as Icon from "react-bootstrap-icons";
import { useState, useRef, useEffect, Fragment } from "react";
import { DebounceInput } from "react-debounce-input";
import { useDispatch, useSelector } from "react-redux";
import { addSelectedUrl, fetchCrawlUrl, fetchUrlListing, urlDelete, urlDeleteMultiple } from "../../redux/actions/chatAiActions";
import { db } from '../../firebase'; // Update the path to your firebaseConfig.js file
import { ref, onValue } from 'firebase/database';
import Loading from "../assetLibComponents/Loading";
import * as types from "../../constants/ChatAiActionTypes";
import Toast from "../assetLibComponents/shared/Toast";
import { ArrowLeft } from "react-bootstrap-icons/dist";
import { ExclamationTriangleIcon  } from "@heroicons/react/24/outline";
import ChatbotViewer from "./ChatbotViewer";
import { Dialog, Transition } from '@headlessui/react'
import { Mixpanel } from "../../Mixpanel";


const ChatUrl = (props) => {
  const dispatch = useDispatch();
  
  const urlListingRef = useRef();
  const cancelButtonRef = useRef(null)
  const [searchValue, setSearchValue] = useState("");
  const [url, setUrl] = useState("");
  const [paginatedData, setPaginatedData] = useState([]);
  const [urlCopy, setUrlCopy] = useState("");
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [subPageCheck, setSubPageCheck] = useState("0");
  const [deleteUrl, setDeleteUrl] = useState({});
  const [selectedUrls, setSelectedUrls] = useState([]);
  const [selectedCrawlUrls, setSelectedCrawlUrls] = useState([]);
  const [counter, setCounter] = useState(1);
  const url_processing = useSelector((state) => state.chatAi.url_processing);
  const [open, setOpen] = useState(false)
  const debugger_mode = useSelector((state) => state.assetLibrary?.debugger_mode);
  const client_id = useSelector((state) => state.assetLibrary?.userData?.client_id);
  const num_client_id = useSelector((state) => state.assetLibrary?.userData?.new_client_id);
  const crawledUrl = useSelector((state) => state.chatAi.crawledUrl);
  const isLoading = useSelector((state) => state.chatAi.loading);
  const crawlLoading = useSelector((state) => state.chatAi.crawlLoading);
  const api_call_hider = useSelector((state) => state.chatAi.apiCallHider);
  const urlListing = useSelector((state) => state.chatAi.urlListing);
  const total_page = Math.ceil(urlListing?.details?.total_count / 10);

  
  const handleCheckboxChange = (obj) => {
    if (selectedUrls.includes(obj)) {
      setSelectedUrls(selectedUrls.filter(item => item !== obj));
    } else {
      setSelectedUrls([...selectedUrls, obj]);
    }
  };
  
  const handleSelectAll = () => {
    setSelectedUrls(crawledUrl?.details?.slice(0,50))
  }
  
  const handleUnSelectAll = () => {
    setSelectedUrls([]);
  }
  
  const handleUrlCheckboxChange = (e,obj) => {
    if (e.target.id !== "anchor_heading") {
      if (selectedCrawlUrls.includes(obj)) {
        setSelectedCrawlUrls(selectedCrawlUrls.filter(item => item !== obj));
      } else {
        setSelectedCrawlUrls([...selectedCrawlUrls, obj]);
      }
    }
  };
  
  const handleUrlSelectAll = () => {
    setSelectedCrawlUrls(paginatedData)
  }
  
  const handleUrlUnSelectAll = () => {
    setSelectedCrawlUrls([])
  }

  const handleRemoveSearch = (e) => {
    setSearchValue("");
    dispatch(fetchUrlListing(props.authToken,"", 1));

  };
  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    dispatch(fetchUrlListing(props.authToken, e.target.value,1));
    setCounter(1);
  };
  const handleModalClose = (e) => {
    setModal(false);
    dispatch({
      type: types.CRAWLED_URL,
      payload: null,
    });
    setSelectedUrls("");
    setSubPageCheck("1");
  };
  
  const scrollToTop = () => {
    if (urlListingRef.current) {
      urlListingRef.current.scrollTop = 0;
    }
  };

  const handleSelection = async () => {
    if(selectedUrls?.length > 0){
      Mixpanel.track('Crawled Urls',
      {"Crawled Urls Count": selectedUrls?.length});
      setCounter(1);
      await dispatch(addSelectedUrl(props.authToken, "crawl", urlCopy, selectedUrls));
      scrollToTop();
      setModal(false);
      setSelectedUrls("");
      setSubPageCheck("0");
      dispatch({
        type: types.CRAWLED_URL,
        payload: null,
      });
    }else {
      Toast("Select Urls", "E");
    }
  }
  
  const checkUrl = (value) => {
    if (value.includes(".")) {
        handleCrawl();
    } else {
        Toast("Please Enter Valid Url", "E");
    }
  }
  
  useEffect(() => {
    const crawlingRef = ref(db, `/users/${num_client_id}/crawling`);
    const onIdStatusChange = onValue(crawlingRef, (snapshot) => {
      const idStatus = snapshot.val();
      if (idStatus !== null) {
        const arrayOfObjects = Object.values(idStatus).map((key) => {
          if (key.status === "completed") {
            return key.id;
          }
        });
        const filteredArray = arrayOfObjects.filter((element) => {
          return element !== undefined;
        });
        firebaseDataHandle(filteredArray);
      }
    });
    
    const deletingRef = ref(db, `/users/${num_client_id}/deleting`);
    
    const ondeleteIdStatusChange = onValue(deletingRef, (snapshot) => {
      const idDeleteStatus = snapshot.val();
      if (idDeleteStatus !== null) {
        const arrayOfDeletedObjects = Object.values(idDeleteStatus).map((key) => {
          if (key.status === "deleted") {
            return key.id;
          }
         
        });
        
        const filteredDeletedArray = arrayOfDeletedObjects.filter((element) => {
          return element !== undefined;
        });
        firebaseDeleteDataHandle(filteredDeletedArray);
      }
    });

    return () => {
      // Cleanup by detaching the listener when component unmounts
      onIdStatusChange();
      ondeleteIdStatusChange();
    };
  }, [paginatedData]);
  
  const firebaseDeleteDataHandle = (checkArray) => {
    let arrayData = [...paginatedData]
    const updatedDeletedArray = arrayData.filter(obj => !checkArray.includes(obj.id));
    setPaginatedData(updatedDeletedArray);
  }
  
  const firebaseDataHandle = (checkArray) => {
    let arrayData = [...paginatedData]
    const updatedArray = arrayData.map((obj) => {
      if (checkArray.includes(obj.id)) {
        // Update the properties you want to change
        obj.status = "done";
      }
      return obj; // No change needed
    });    
    setPaginatedData(updatedArray);
  }
  
  useEffect(() => {
    urlListingRef.current.addEventListener('scroll', handleScroll);
    return () => {
      if (urlListingRef?.current) {
        urlListingRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  
  const handleScroll = async () => {
    const { scrollTop, clientHeight, scrollHeight } = urlListingRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 2) {
      setCounter((prevPage) => prevPage + 1);
    }
  };
  
  useEffect(() => {
    if (counter <= total_page && counter !== 1) {
      callPaginationApi();
    }
  }, [counter])
  
  const callPaginationApi = async () => {
      await dispatch(fetchUrlListing(props.authToken, "", counter, api_call_hider));
  }
  
  const handleCrawl = () => {
    if(url?.length > 0){
      dispatch(fetchCrawlUrl(props.authToken, url ,subPageCheck));
      setModal(true);
      setUrlCopy(url)
      setUrl("")
      setSelectedUrls("")
    }else{
      Toast("Please Enter Url", "E");
    }
  };
  
  const handleStatus = (status) => {
    if (status === "queued" || status === "done" || status === "failed" || status === "queued for deletion") {
      return true;
    } else {
      return false;
    }
  }
  
  const handleDelete = (did,type) => {
    setDeleteModal(true)
    if (type === "crawled_url") {
      setDeleteUrl({ id: did, type: type });
    } else {
      setDeleteUrl({ id: null, type: type });
    }
  };
  
  const multipleDelete = (crawlUrlDelete, pass) => {
    handleDelete(crawlUrlDelete, pass);
  }

  const deleteHandleClose = () => {
    setDeleteModal(false)
    setDeleteUrl({})
  };
  
  const handleMultipleRecrawl = () => {
    let recrawlUrl = [];
    for (var i = 0; i < selectedCrawlUrls.length; i++) {
      let url = selectedCrawlUrls[i];
      let tempUrl = {
        id: url.id,
        url: url.url,
        total_items: null
      }
      recrawlUrl.push(tempUrl);
      if (url.status !== "failed") {
        Toast("Please Select only failed URLs to recrawl", "E");
        break;
      } else {
        if (i === selectedCrawlUrls.length-1) {
          dispatch(addSelectedUrl(props.authToken, "re-crawl", "", recrawlUrl));
          handleUrlUnSelectAll();
        }
      }
    }
  }
    
  const chatOpenHandle = (value) => {
    setOpen(value);
  }

  useEffect(() => {
    dispatch(fetchUrlListing(props.authToken, "", 1, api_call_hider));
    setSubPageCheck("1");
  }, []);
  
  useEffect(() => {
    if (counter > 1) {
      setPaginatedData((prevData) => [...paginatedData, ...urlListing?.details?.crawled_url]);
    } else {
      setPaginatedData(urlListing?.details?.crawled_url);
    }
  }, [urlListing]);

  return (
    <>
      {(isLoading) && <Loading />}
      <div>
        {/* Heading with Button */}
      <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
          <div className="text-lg leading-7 font-[500] my-auto">Crawl URL</div>
          <button
            onClick={()=>{setOpen(true)}}
            type="button"
            className="inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
           >
           <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" />
            Test ChatAI
          </button>     
      </div>
        {/* Input Field with Crawl Button */}
        <div className="w-full flex my-6 max-sm:mb-2 mx-auto">
          <div className="flex max-sm:block w-full">
          <div className="bg-white relative flex justify-between px-2 rounded-[6px] w-full">
          <input
              className="relative max-sm:w-full w-[70%] border-none inputBorder"
              placeholder="Enter URL to Crawl"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
            <div className="check-box-input my-auto flex max-sm:absolute bottom-[-30px] left-0">
                <input
                  type="checkbox"
                  className="me-2"
                  checked={subPageCheck === "1" ? true : false}
                  onChange={(e) => {
                    setSubPageCheck(e.target.checked === true ? "1":"0")
                  }}
                />
              <span className="not-italic font-medium text-xs leading-[15px] max-sm:text-[10px] text-[#111827] my-auto">Include Sub Pages</span>
              </div>
          </div>
          <div className="my-auto max-sm:mr-0 max-sm:my-2 max-sm:ml-auto max-sm:w-[20%] max-sm:text-center cursor-pointer border border-gray-300 rounded-[6px] py-1 ml-2 px-2 text-sm leading-5 font-semibold" onClick={()=>{checkUrl(url)}}>
            Crawl
          </div>
          </div>
        </div>
        {/* Listing Url */}
        <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
        {/* Listing Heading With Search */}
        <div className="px-4 py-5 sm:px-6 flex justify-between">
          <div className="non-italic text-base leading-6 font-semibold my-auto">
             Crawled URLs
          </div>
          <div className="relative rounded-md shadow-sm my-auto max-sm:w-[50%]">
            <DebounceInput
                value={searchValue}
                className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                placeholder="Search"
                minLength={3}
                debounceTimeout={500}
                onChange={handleSearch}
              />
              <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
                {searchValue && searchValue !== "" ? (
                    <Icon.X className="h-4 w-4 text-gray-400 pointer" onClick={handleRemoveSearch} />
                  ) : (
                    <Icon.Search className="h-4 w-4 text-gray-400 cursor-pointer" onClick={handleSearch} />
                  )}
              </div>
          </div> 
        </div>
          
        {/* Top Bar */}
        {selectedCrawlUrls.length > 0 && <div className="flex text-xs max-sm:m-auto items-center justify-between bg-[#F3F4F6]">
          <div className="flex max-sm:flex-col text-xs max-sm:m-auto items-center w-full max-sm:w-auto justify-between max-sm:px-1 px-4 sm:px-6 max-sm:py-2 py-5 sm:p-1.5 bg-[#F3F4F6] border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)]">
            <div className="max-sm:mb-2 max-sm:font-bold">{selectedCrawlUrls?.length} Selected</div>
            <div className="flex ml-auto mr-0 items-center">
              <div className="hover:bg-[#D1D5DB] hover:border-[rgba(83,85,86,0.1)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-3 max-sm:ms-0" onClick={()=>{handleMultipleRecrawl()}}>
                    <Icon.ArrowRepeat className="max-sm:hidden"/> <span>Re-Crawl</span>
              </div>
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={() => { multipleDelete(selectedCrawlUrls, "multiple"); }}>
                    <Icon.Trash3 className="max-sm:hidden"/> <span>Delete</span>
              </div>
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={handleUrlUnSelectAll}>
                    <Icon.Subtract className="max-sm:hidden"/> <span>Unselect All</span>
              </div>
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={handleUrlSelectAll}>
                  <Icon.UiChecks className="max-sm:hidden"/> <span>Select All</span>
              </div>
            </div>
          </div>
        </div>}          

        {/* Listing */}
        <div className={(paginatedData?.length > 0 ? "divide-y divide-gray-200 overflow-y-scroll listing ":"flex justify-center items-center ")+(selectedCrawlUrls.length > 0 ? "xl:h-[44vh] md:h-[38vh] h-[38vh]" : "xl:h-[50vh] md:h-[45vh] h-[45vh]")} ref={urlListingRef}>
        {paginatedData?.length > 0 && paginatedData.map((item,index) => {
          return(
            <div key={"item-" + index} className={"flex px-4 sm:px-6 py-5 sm:p-4 " + (selectedCrawlUrls.includes(item) && "bg-[#ECFEFF]")}>
              <div className="listing-check my-auto flex">
                <input
                  type="checkbox"
                  className="me-2"
                  onChange={(e) => handleUrlCheckboxChange(e, item)}
                  checked={selectedCrawlUrls.includes(item)}
                />
              </div>
              <span title={item?.url} className={"flex justify-start w-[75%]" + (handleStatus(item.status) ? " max-sm:w-[44%] " : " max-sm:w-[60%] ")}><a id="anchor_heading" href={item?.url} className="cursor text-gray-900 text-sm not-italic font-medium w-full inline-block overflow-hidden text-ellipsis whitespace-nowrap ml-2.5" target="blank">{item?.url}</a></span>
              
              <div className={"w-[25%] flex justify-end" + (handleStatus(item.status) ? " max-sm:w-[50%] " : " max-sm:w-[40%] ")}>
                {(item.status === "queued" || item.status === "processing") && <span className="animate-pulse inline-flex items-center gap-x-0.5 rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                  Crawling...
                </span>}
                {item.status === "done" && <span className="inline-flex items-center gap-x-0.5 rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                  Done
                </span>}
                {item.status === "failed" && <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10"
                  // onClick={() => {
                  //     let urlSingle = {
                  //         id: item.id,
                  //         url: item.url,
                  //         total_items: null
                  //     }
                  //       dispatch(addSelectedUrl(props.authToken, "re-crawl", item?.url, [urlSingle]));
                  //       setCounter(1);
                  //   }
                  // }
                >
                  Recrawl
                </span>}
                {item.status === "queued for deletion" && <span className="animate-pulse inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                  Removing...
                </span>}
                <span className="text-[rgba(33,33,33,0.30)] text-xs not-italic font-semibold ml-[25px] max-sm:ml-[10px] flex items-center cursor-pointer text-[12px] leading-3">
                  {item?.date.slice(0,6)}
                </span>
                {/* {(debugger_mode !== 0 && item?.debug !== null) && <span className="text-[rgba(33,33,33,0.30)] text-xs not-italic font-semibold ml-[25px] flex items-center cursor-pointer text-[12px] leading-3">
                  <a href={item.debug} title={item.debug} target='blank' className='flex items-center justify-center left-[-30px] border text-[#59B3C6] text-xs w-5 text-center h-5 cursor-pointer rounded-[50%] border-solid border-[#59B3C6] bottom-0'><Icon.BugFill/></a>
                </span>} */}
                
                <span className="ml-[25px] max-sm:ml-[10px]" onClick={(e) => handleUrlCheckboxChange(e, item)}>
                  <Icon.ThreeDotsVertical title="select" className={(selectedCrawlUrls.includes(item) ? 'cursor-pointer text-[20px] text-[var(--brand-primary)]':"cursor-pointer text-[20px] text-[#A8A8A8] hover:text-[var(--brand-primary)]")}/>
                </span>
              </div>
            </div>
          )
        })}
        {(paginatedData?.length === 0) && (
          <div className="text-[rgba(33,33,33,0.3)] text-[17px] font-[bolder] text-center font-add">
            <span className="flex justify-center text-[40px]">
              <Icon.Inbox />
            </span>
            No Data
          </div>
        )}
        </div>
       </div>
        
        {/* Change to Tailwind */}
        <Transition.Root show={modal && crawlLoading} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleModalClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#f2f2f2] px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-16 sm:px-12">
                    <div className="flex flex-wrap p-1">
                      <div className="w-1/3 px-1">
                        <div className="not-italic font-bold text-2xl max-sm:text-[17px] leading-[29px] text-[#00000094]">Getting to know more</div>
                      </div>
                      <div className="w-2/3 flex flex-col ms-auto">
                        <div className="not-italic font-semibold text-base leading-6 text-[#00000060] w-full inline-block whitespace-nowrap text-right overflow-hidden text-ellipsis pr-5">{urlCopy}</div>
                        <div className="animate-pulse mt-2 flex flex-row justify-center items-center gap-1.5 w-[140px] h-[26px] bg-[rgba(33,33,33,0.12)] not-italic font-bold text-xs leading-[15px] text-right text-[#00000094] px-2.5 py-[5px] rounded-[20px] ms-auto">
                          Crawling...
                          <span
                            onClick={() => {
                              handleModalClose()
                            }}
                          >
                            <Icon.X
                              className="fs-5 cursor-pointer"
                              color="#00000094"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        
        <Transition.Root show={modal && !crawlLoading} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleModalClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#f2f2f2] px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-4 sm:px-4">
                    <div className="flex flex-col p-1">
                      <div className="flex ">
                        <div className="not-italic font-bold max-sm:text-[20px] text-2xl leading-[29px] text-[#00000094]">Here are the Results!</div>
                        <div className="ms-auto flex">
                          <div className="flex flex-row justify-center items-center gap-1.5 hover:bg-[#00000070] hover:border-[#00000025] border border-[#00000025] bg-[#00000050] not-italic font-bold text-xs leading-[15px] text-right text-[#ffffff] px-2.5 py-[5px] rounded-[20px] cursor-pointer ms-3" onClick={handleSelection}>
                            Submit to AI
                          </div>
                        </div>
                      </div>
                      {(subPageCheck === "1" && selectedUrls?.length > 0) && <div className="flex items-center bg-[#b4b4b426] text-[#00000094] text-[13px] h-[25px] mt-3 px-2.5 rounded-[10px] py-[15px] border-solid">
                        {selectedUrls?.length} Selected
                        <div className="flex ml-auto mr-0 justify-end">
                          <div className="hover:bg-[#dfdfdf66] hover:border-[#00000025] cursor-pointer items-center flex flex-row text-xs not-italic gap-1.5 justify-center leading-[15px] rounded-[20px] bg-[#ffffff54] border text-[#00000094] font-medium px-2.5 py-0.5 border-solid border-[#00000025]" onClick={handleSelectAll}>
                                <Icon.UiChecks/>Select the first 50
                          </div>
                          <div className="hover:bg-[#dfdfdf66] hover:border-[#00000025] cursor-pointer items-center flex flex-row text-xs not-italic gap-1.5 ml-2 justify-center leading-[15px] rounded-[20px] bg-[#ffffff54] border text-[#00000094] font-medium px-2.5 py-0.5 border-solid border-[#00000025]" onClick={handleUnSelectAll}>
                                <Icon.Subtract/> Unselect All
                            </div>
                        </div>
                      </div>}
                      <div className="mt-3 ms-4 max-sm:ms-2 scrollable-popup-window">
                        {crawledUrl?.details?.map((item,index) => {
                          return (
                            <>
                            <div className="flex items-center px-2 my-auto popCheck mt-2" key={item.id}>
                              <input
                                className="my-auto focus:shadow-none"
                                type="checkbox"
                                onChange={() => handleCheckboxChange(item)}
                                checked={selectedUrls.includes(item)}
                              />
                              <div className="my-auto ms-2 not-italic font-semibold text-base leading-6 text-[#00000094] w-full inline-block whitespace-nowrap overflow-hidden text-ellipsis pr-5" title={item?.url}>
                                {item?.url?.length > 55 ? `${item?.url.substring(0, 55)}...` : item?.url}
                              </div>
                            </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        
        <Transition.Root show={deleteModal} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={deleteHandleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                          <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                        </div>
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                            Delete crawled URL(s)?
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Are you sure you want to delete the selected URL(s)?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                        onClick={async () => {
                          setCounter(1);
                          if (deleteUrl?.type !== "crawled_url") {
                              await dispatch(urlDeleteMultiple(props.authToken, selectedCrawlUrls));
                          } else {
                              await dispatch(urlDelete(props.authToken,deleteUrl));
                          }
                          scrollToTop();
                          setSelectedCrawlUrls([]);
                          deleteHandleClose();
                        }}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={() => deleteHandleClose(false)}
                        ref={cancelButtonRef}
                      >
                        No
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      
        {/* Chatbot testing */}
        <ChatbotViewer authToken={props.authToken} open={open} chatOpenHandle={chatOpenHandle} autoQuestion="" />
      </div>
    </>
  );
};

export default ChatUrl;
